module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.marketDetails)
  }, [(_vm.market) ? _c('table', {
    staticClass: "market"
  }, [_c('tr', {
    staticClass: "market-row"
  }, [(_vm.silkImageUrl) ? _c('td', {
    staticClass: "silk"
  }, [_c('img', {
    attrs: {
      "src": _vm.silkImageUrl,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v("\n        " + _vm._s(_vm.market.num) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name",
    class: {
      scratched: _vm.market.scratched
    }
  }, [_vm._v("\n          " + _vm._s(_vm.market.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "market-data-jockey"
  }, [_vm._v(_vm._s(_vm.market.jockey))]), _vm._v(" "), (!_vm.market.scratched && _vm.market.jockey && _vm.market.trainer) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "market-data-trainer"
  }, [_vm._v(_vm._s(_vm.market.trainer))])])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price",
    style: (_vm.currentPrice)
  }, [(_vm.market.price) ? _c('span', [_vm._v(_vm._s(_vm.displayPrice))]) : _vm._e(), _vm._v(" "), (!_vm.market.price && !_vm.market.scratched) ? _c('span', [_vm._v("SP")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "prev",
    style: (_vm.previousPrice)
  }, [(_vm.market.previousPrice) ? _c('span', [_vm._v(_vm._s(_vm.previousDisplayPrice))]) : _vm._e(), _vm._v(" "), (!_vm.market.previousPrice && !_vm.market.scratched) ? _c('span', [_vm._v("SP")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('td', {
    staticClass: "place",
    style: (_vm.placePrice)
  }, [_vm._v("\n        " + _vm._s(_vm.placeDisplayPrice) + "  \n      ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46963633","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MarketSmall.vue
// module id = 232
// module chunks = 1